import React, { useEffect } from 'react'
import { useSession } from 'packages/@slerp/accounts'
import { GET_LIGHTSPEED_STORES } from 'router/queries'
import { LightspeedStore } from 'components/Integrations/Manage/ManageLightspeed/types'
import { useIntegration } from 'hooks/useGlobalContext/useIntegration'
import { LoaderProps } from './types'
import { useFetchOnce } from './useFetchOnce'

export const LightspeedStoresLoader = ({
  isParentLoaded = true,
  children
}: LoaderProps) => {
  const { merchant } = useSession()
  const {
    lightspeedStores,
    setLightspeedStores,
    setLightspeedStoresLoading,
    setRefetchLightspeedStores
  } = useIntegration()

  const { isLoaded, loading } = useFetchOnce<{
    stores: LightspeedStore[]
  }>({
    query: GET_LIGHTSPEED_STORES,
    skip: !merchant?.id || lightspeedStores.length > 0,
    variables: { merchantId: merchant?.id },
    onData: (data) => {
      if (data.stores) {
        setLightspeedStores(data.stores)
      }
    },
    onRefetch: (refetch) => {
      const refetchAndSync = async () => {
        const result = (await refetch()) as {
          data?: { stores: LightspeedStore[] }
        }
        if (result.data?.stores) {
          setLightspeedStores(result.data.stores)
        }
        return result
      }

      setRefetchLightspeedStores(
        (() => refetchAndSync) as unknown as () => Promise<unknown>
      )
    },
    isReady: (loading) => !merchant?.id || !loading,
    isParentLoaded
  })

  useEffect(() => {
    setLightspeedStoresLoading(loading)
  }, [loading])

  return <React.Fragment>{children(isLoaded)}</React.Fragment>
}
